import React from "react";
import CourseListItem from "src/components/molecules/Courses/CourseListItem";
import { usePagination } from "src/contexts/PaginationContext";

const CourseList: React.FC = () => {
  const { data, isSuccess } = usePagination();
  if (!isSuccess) return <div>Loading</div>;
  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-md">
      <ul role="list" className="divide-y divide-gray-200">
        {data.map((course) => (
          <CourseListItem key={course.id} course={course} />
        ))}
      </ul>
    </div>
  );
};

export default CourseList;
